import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ServiceAppService } from './../../../security/service-app.service';
import { IFiltros, ITotais } from './interface-apuracao-vdm';
import { ApuracaoVdmHistoricoComponent } from './apuracao-vdm-historico/apuracao-vdm-historico.component';
import { ApuracaoVdmPrincipalComponent } from './apuracao-vdm-principal/apuracao-vdm-principal.component';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';

@Component({
  selector: 'app-apuracao-vdm',
  templateUrl: './apuracao-vdm.component.html',
  styleUrls: ['./apuracao-vdm.component.scss']
})
export class ApuracaoVdmComponent implements OnInit {
  cols: any[];
  colsFooter: any[];
  dados: any[];
  loading: boolean;
  nomeModulo: string;

  filtros: IFiltros = {
    dataAno: null,
    considerarBalcao: false,
    selecaoVdm: true
  };

  //Váriáveis do dropDown de Ano para o filtro.
  ano: any;
  anoAtual = new Date();
  anoAnterior = new Date();
  anoRetrasado = new Date();
  anoPosterior = new Date();
  anoDropDown: any[] = [];

  totais: ITotais = {
    totalBudgetFull: 0,
    totalBudgetYtd: 0,
    totalPendenteFull: 0,
    totalPendenteYtd: 0,
    totalRealizado: 0
  }

  parametros: string = '';

  @ViewChild('dt') dt: Table;
  @ViewChild('principal') apuracaoVdmPrincipal: ApuracaoVdmPrincipalComponent;
  @ViewChild('historico') apuracaoVdmHistorico: ApuracaoVdmHistoricoComponent
  constructor(private service: ServiceAppService,
    private exportExcelService: ExportExcelService
  ) {
    this.nomeModulo = 'Apuração VDM - Peças';
  }

  ngOnInit(): void {
    this.geraAnoDropDown();
    this.setaValorData();

    this.cols = [
      { field: 'codDealer', header: 'Dealer' },
      { field: 'nomeDealer', header: 'Nome' },
      { field: 'budgetFull', header: 'Budget Full' },
      { field: 'budgetYtd', header: 'Budget YTD' },
      { field: 'realizado', header: 'Realizado' },
      { field: 'pendenteFull', header: 'Pendente Full' },
      { field: 'pendenteYtd', header: 'Pendente YTD' },
    ];
  }

  ngAfterViewInit() {
    this.retornaDados();
  }

  retornaDados() {
    this.loading = true;
    this.service.getDados(`/apuracao_vdm?dataAno=${this.filtros.dataAno}&selecaoVdm=${this.filtros.selecaoVdm}&considerarBalcao=${this.filtros.considerarBalcao}`).subscribe(res => {
      this.dados = res.dados;

      this.totais = {
        totalBudgetFull: res.totalBudgetFull,
        totalBudgetYtd: res.totalBudgetYtd,
        totalPendenteFull: res.totalPendenteFull,
        totalPendenteYtd: res.totalPendenteYtd,
        totalRealizado: res.totalRealizado
      }

      this.apuracaoVdmPrincipal.retornaDados();
      this.apuracaoVdmHistorico.retornaDados();
      this.loading = false;
    });
  }

  setaValorData() {
    if (this.filtros.dataAno === undefined || this.filtros.dataAno === null) {
      var data = new Date();
      var mes = String(data.getMonth() + 1).padStart(2, '0')
      if (parseInt(mes) >= 7) {
        this.filtros.dataAno = this.anoPosterior.getFullYear() + 1;
      } else {
        this.filtros.dataAno = this.anoAtual.getFullYear();
      }
    }

    this.retornaDados();
  }

  alteraValorFiltroVdm() {
    this.retornaDados();
  }

  set Ano(ano: any) { this.filtros.dataAno = this.tratarSetDropDown(ano); }
  get Ano(): any { return this.tratarGetDropDown(this.filtros.dataAno); }

  tratarSetDropDown(id: string): number {
    if (id) {
      return +id;
    } else {
      return null;
    }
  }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }

  private geraAnoDropDown() {
    this.anoDropDown = [
      { name: this.anoRetrasado.getFullYear() - 2, code: this.anoRetrasado.getFullYear() - 2 },
      { name: this.anoAnterior.getFullYear() - 1, code: this.anoAnterior.getFullYear() - 1 },
      { name: this.anoAtual.getFullYear(), code: this.anoAtual.getFullYear() },
      { name: this.anoPosterior.getFullYear() + 1, code: this.anoPosterior.getFullYear() + 1 }
    ]
  }

  public exportExcel() {
    let registros = [];
    let registrosPrincipal = [];
    let registrosHistorico = [];

    this.service.getDados(`/apuracao_vdm?dataAno=${this.filtros.dataAno}&selecaoVdm=${this.filtros.selecaoVdm}&considerarBalcao=${this.filtros.considerarBalcao}`).subscribe(res => {
      registros = res.dados;
      if (registros.length > 0) {
        this.exportExcelService.nomeModulo = this.nomeModulo;
        this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
          let linha = {};
          this.cols.forEach(c => {
            linha[(c.header)] = (r[c.field]);
          });
          return linha;
        }));
      }
    });

    this.service.getDados(`/apuracao_vdm_mensal?dataAno=${this.filtros.dataAno}&selecaoVdm=${this.filtros.selecaoVdm}&considerarBalcao=${this.filtros.considerarBalcao}`).subscribe(res => {
      registrosPrincipal = res.dados;
      if (registrosPrincipal.length > 0) {
        this.exportExcelService.nomeModulo = "Apuração VDM - Peças/Principal";
        this.exportExcelService.ExportTOExcelJSON(registrosPrincipal.map(r => {
          let linha = {};
          this.apuracaoVdmPrincipal.cols.forEach(c => {
            linha[(c.header)] = (r[c.field]);
          });
          return linha;
        }));
      }
    });

    this.service.getDados(`/apuracao_vdm_historico?dataAno=${this.filtros.dataAno}&selecaoVdm=${this.filtros.selecaoVdm}&considerarBalcao=${this.filtros.considerarBalcao}`).subscribe(res => {
      registrosHistorico = res.dados;
      if (registrosHistorico.length > 0) {
        this.exportExcelService.nomeModulo = "Apuração VDM - Peças/Histórico";
        this.exportExcelService.ExportTOExcelJSON(registrosHistorico.map(r => {
          let linha = {};

          this.apuracaoVdmHistorico.cols.forEach(c => {
            linha[(c.header)] = (r[c.field]);
          });
          return linha;
        }));
      }
    });
  }
}